import type { ReactNode } from 'react';
import { useSession } from '../features/session/useSession';

/** Returns true when the actor carries the given permission code. */
export function hasPermission(
  permissions: string[] | undefined | null,
  code?: string | string[],
): boolean {
  if (!code) {
    return true;
  }
  if (!permissions?.length) {
    return false;
  }
  const required = Array.isArray(code) ? code : [code];
  return required.some((c) => permissions.includes(c));
}

/** Hook reading effective permissions from the Me query. */
export function usePermissions(): string[] {
  const { me } = useSession();
  return me?.permissions ?? [];
}

/** Conditionally render children when the session has the permission. */
export function Can({
  permission,
  children,
  fallback = null,
}: {
  permission?: string | string[];
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const permissions = usePermissions();
  if (!hasPermission(permissions, permission)) {
    return fallback;
  }
  return children;
}
